/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import CodeList from "../lib/CodeList";
import $ from "jquery";
import { Link } from "react-router-dom";
import BuddibleSocket, { MsgIDList } from "../lib/BuddibleSocket";
import Utilities from "../lib/Utilities";
import UploadImageToS3WithPhp from "../lib/UploadImageToS3WithPhp";
import LogoSvg from "../assets/LogoSvg";
import { useTranslation } from "react-i18next";

window.jQuery = $;
window.$ = $;
global.jQuery = $;
const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

let isCheck = false;
let isUser = false;
export default function RegistModal() {
  const [loading, setLoading] = useState(false);
  const [uploadFiles, setUploadFiles] = useState("");
  const [compGB, setCompGB] = useState("");
  const [registView, setRegistView] = useState(0);
  const { t } = useTranslation();
  const $controllers = {
    comp_gb: useRef(),
    comp_mail: useRef(),
    comp_num: useRef(),
    comp_nm: useRef(),
    comp_c_num: useRef(),
    fwd_no: useRef(),
    comp_ceo_nm: useRef(),
    comp_addr: useRef(),
    comp_upte: useRef(),
    comp_jong: useRef(),
    comp_tel: useRef(),
    comp_fax: useRef(),
    comp_zip: useRef(),
    img_saup: useRef(),
  };

  const $termsController = {
    termsOfUse: useRef(),
    mallOperationPolicy: useRef(),
    talkOperationPolicy: useRef(),
    privacyPolicy: useRef(),
    disclaimer: useRef(),
  };

  useEffect(() => {
    socket.addLocalEventListener(
      MsgIDList.EVENT_SOCKET_DATA_ERROR,
      "RegistModal",
      (b, n) => {
        setLoading(false);
      }
    );

    return () => {
      socket.removeLocalEventListener(
        MsgIDList.EVENT_SOCKET_DATA_ERROR,
        "RegistModal"
      );
    };
  }, []);

  function uploadFile(val) {
    if (val.ret) {
      const changedFileName = val.fileName;
      const filename = `${val.realFileName}*${changedFileName}`;
      setUploadFiles(filename);
    } else {
      codeList.Modal.current.alert(
        t("commonNav.registrationCorpModal.msg.uploadError"),
        () => {}
      );
    }
  }

  //첨부파일 삭제
  function deleteFile(url, name) {
    let splitData = uploadFiles.split("|");
    let index = splitData.findIndex((item) => {
      return item === `${name}*${url}`;
    });

    if (index > -1) {
      splitData.splice(index, 1);
      const pmFiles = splitData.join("|");
      setUploadFiles(pmFiles);
    }
  }

  function actionSave(e) {
    if (!isCheck) {
      codeList.Modal.current.alert(
        t("commonNav.registrationCorpModal.msg.checkDuplicateBizNum")
      );
      return;
    }
    if (isUser) {
      codeList.Modal.current.alert(
        t("commonNav.registrationCorpModal.msg.alreadyBizNum")
      );
      return;
    }

    setLoading(true);
    if (checkValidation()) {
      let splitData = uploadFiles.split("*");
      if (splitData.length === 1) {
        codeList.Modal.current.alert(
          t("commonNav.registrationCorpModal.msg.uploadBizDoc")
        );
        return;
      }
      let fileLink = `${splitData[1]}`;

      let updateData = {
        comp_gb: $controllers.comp_gb.current.value.trim(),
        comp_mail: $controllers.comp_mail.current.value.trim(),
        comp_num: $controllers.comp_num.current.value
          .trim()
          .replaceAll("-", ""),
        comp_nm: $controllers.comp_nm.current.value.trim(),
        comp_c_num: $controllers.comp_c_num.current.value.trim(),
        fwd_no: $controllers.fwd_no.current.value.trim(),
        comp_ceo_nm: $controllers.comp_ceo_nm.current.value.trim(),
        comp_addr: $controllers.comp_addr.current.value.trim(),
        comp_upte: $controllers.comp_upte.current.value.trim(),
        comp_jong: $controllers.comp_jong.current.value.trim(),
        comp_tel: $controllers.comp_tel.current.value.trim(),
        comp_fax: $controllers.comp_fax.current.value.trim(),
        comp_zip: $controllers.comp_zip.current.value.trim(),
        img_saup: fileLink,
      };
      requestUserUpdate(updateData);
    } else {
      setLoading(false);
    }
  }

  function CHECK_COMP_NUM() {
    setLoading(true);
    if ($controllers.comp_num.current.value.trim === "") {
      codeList.Modal.current.alert(
        t("commonNav.registrationCorpModal.msg.enterBizNum")
      );
      return;
    }

    let compNumCheck = util.validationBizID(
      $controllers.comp_num.current.value
    );
    if (!compNumCheck) {
      codeList.Modal.current.alert(
        t("commonNav.registrationCorpModal.msg.invalidBizNum")
      );
      return;
    }

    let msgID = util.makeUUIDv4();
    let socketMsg = {
      file: "/join/JS_comp_join_check.php",
      msgID: msgID,
      data: {},
      COMP_NUM: $controllers.comp_num.current.value,
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"] === true) {
          if (newData["cnt"] === 1) {
            codeList.Modal.current.alert(
              t("commonNav.registrationCorpModal.msg.alreadyBizNum")
            );
            isUser = true;
          } else {
            codeList.Modal.current.alert(
              t("commonNav.registrationCorpModal.msg.validBizNum")
            );
            isUser = false;
            isCheck = true;
          }
        } else {
          codeList.Modal.current.alert(
            t("commonNav.registrationCorpModal.msg.bizNumError")
          );
        }
        setLoading(false);
      }
    });
  }

  function checkValidation() {
    if ($controllers.comp_gb.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("commonNav.registrationCorpModal.msg.selectCompType")
      );
      return false;
    }
    if ($controllers.comp_mail.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("commonNav.registrationCorpModal.msg.enterEmail")
      );
      return false;
    }
    if ($controllers.comp_num.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("commonNav.registrationCorpModal.msg.enterBizNum")
      );
      return false;
    }
    if ($controllers.comp_num.current.value.trim().indexOf("-") > -1) {
      codeList.Modal.current.alert(
        t("commonNav.registrationCorpModal.msg.invalidBizNum")
      );
      return false;
    }

    if ($controllers.comp_nm.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("commonNav.registrationCorpModal.msg.enterCompName")
      );
      return false;
    }

    if ($controllers.comp_ceo_nm.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("commonNav.registrationCorpModal.msg.enterCEOName")
      );
      return false;
    }

    if ($controllers.comp_tel.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("commonNav.registrationCorpModal.msg.enterTel")
      );
      return false;
    }
    if (uploadFiles === "") {
      codeList.Modal.current.alert(
        t("commonNav.registrationCorpModal.msg.uploadBizDoc")
      );
      return false;
    }

    for (let key in $termsController) {
      if ($termsController[key].current.checked === false) {
        codeList.Modal.current.alert(
          t("commonNav.registrationCorpModal.msg.agreeRequiresTerms")
        );
        return false;
      }
    }

    return true;
  }

  function requestUserUpdate(updateData) {
    let msgID = util.makeUUIDv4();
    let socketMsg = {
      file: "/join/JS_join_gbts_user.php",
      msgID: msgID,
      data: {},
      ...updateData,
    };
    //setLoading(true);
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"] === true) {
          codeList.Modal.current.alert(
            t("commonNav.registrationCorpModal.msg.successJoin"),
            () => {}
          );

          for (let key in $controllers) {
            if ($controllers[key].current) {
              $controllers[key].current.value = "";
            }
          }
          for (let key in $termsController) {
            if ($termsController[key].current) {
              $termsController[key].current.checked = false;
            }
          }

          isCheck = false;
          isUser = false;
          setUploadFiles("");
          $("#registModalClose").click();
          let msgID = util.makeUUIDv4();
          let socketMsg = {
            file: "/join/js_join_email_send.php",
            msgID: msgID,
            data: {},
            comp_cd: newData.comp_cd,
            site_gb: "프레이스콥(freiscop)",
            ...updateData,
          };

          socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {});
        } else {
          setLoading(false);
          codeList.Modal.current.alert(
            t("commonNav.registrationCorpModal.msg.errorJoin"),
            () => {}
          );
        }
      }
      setLoading(false);
    });
  }

  function changeCompGB() {
    setCompGB($controllers.comp_gb.current.value);
  }

  return (
    <div
      className="modal fade"
      id="registModal"
      tabIndex="-1"
      aria-labelledby="registModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header" style={{ borderBottom: "none" }}>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="registModalClose"
              onClick={() => {
                isCheck = false;
                isUser = false;

                setRegistView(0);
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="container-fluid">
              <div className="text-lg-center">
                <div id="logo" style={{ marginTop: "-30px" }}>
                  <LogoSvg height="60px" />
                </div>
                <div className="logo  mt-4">
                  <h6 className="m-0 mb-1 text-secondary font-weight-bold">
                    {t("commonNav.registrationCorpModal.title")}
                  </h6>
                </div>
                {/*아이디 패스워드 입력*/}
                <div className="py-3">
                  <div className={registView === 0 ? "" : "d-none"}>
                    <div className="mb-3 row">
                      <label className="col-form-label col-sm-3 text-end">
                        {t("commonNav.registrationCorpModal.compGB")}{" "}
                        <i style={{ color: "red", fontWeight: 700 }}>*</i>
                      </label>
                      <div className="col-sm-9">
                        <select
                          className="custom-select form-control"
                          ref={$controllers.comp_gb}
                          onChange={changeCompGB}
                        >
                          <option value="">
                            {t("commonNav.registrationCorpModal.select")}
                          </option>
                          <option value="A">
                            {t("commonNav.registrationCorpModal.shipper")}
                          </option>
                          <option value="B">
                            {t("commonNav.registrationCorpModal.forwarder")}
                          </option>
                          <option value="C">
                            {t("commonNav.registrationCorpModal.carrier")}
                          </option>
                          <option value="D">
                            {t("commonNav.registrationCorpModal.insurer")}
                          </option>
                          <option value="E">
                            {t("commonNav.registrationCorpModal.customs")}
                          </option>
                          <option value="F">
                            {t(
                              "commonNav.registrationCorpModal.boundedWarehouse"
                            )}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-form-label col-sm-3 text-end">
                        {t("commonNav.registrationCorpModal.bizNum")}
                        <i style={{ color: "red", fontWeight: 700 }}>*</i>
                      </label>
                      <div className="col-sm-9 d-flex flex-row justify-content-between">
                        <div className="flex-fill mr-2">
                          <input
                            maxLength={10}
                            type="text"
                            className="form-control"
                            placeholder={t(
                              "commonNav.registrationCorpModal.placeholderBizNum"
                            )}
                            ref={$controllers.comp_num}
                            disabled={isCheck}
                          />
                        </div>
                        <button
                          className="btn_1"
                          onClick={() => CHECK_COMP_NUM()}
                          disabled={isCheck}
                        >
                          {t("commonNav.registrationCorpModal.checkDuplicate")}
                        </button>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-form-label col-sm-3 text-end">
                        {t("commonNav.registrationCorpModal.bizDoc")}{" "}
                        <i style={{ color: "red", fontWeight: 700 }}>*</i>
                      </label>
                      <div className="col-sm-9">
                        <UploadImageToS3WithPhp
                          region={"saup"}
                          callback={uploadFile}
                        />
                        {uploadFiles !== "" &&
                          uploadFiles.split("|").map((v, i) => {
                            let splitData = v.split("*");
                            if (splitData.length === 1) return null;
                            let fileName = splitData[0];
                            let fileLink = `${splitData[1]}`;
                            return (
                              <div
                                className="my-2"
                                key={v}
                                style={{ textAlign: "start" }}
                              >
                                <button
                                  className="btn btn-danger mr-2"
                                  onClick={() => {
                                    deleteFile(fileLink, fileName);
                                  }}
                                >
                                  {t("commonNav.registrationCorpModal.delete")}{" "}
                                </button>
                                {fileName.endsWith(".pdf") && (
                                  <a
                                    className="font-weight-bold text-decoration-underline"
                                    href={fileLink}
                                    download={fileName}
                                    target="_blank"
                                  >
                                    {fileName}
                                  </a>
                                )}
                                {!fileName.endsWith(".pdf") && (
                                  <a
                                    className="font-weight-bold text-decoration-underline"
                                    href={fileLink}
                                    download={fileName}
                                    target="_blank"
                                  >
                                    {fileName}
                                  </a>
                                )}
                              </div>
                            );
                          })}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-form-label col-sm-3 text-end">
                        {t("commonNav.registrationCorpModal.compName")}{" "}
                        <i style={{ color: "red", fontWeight: 700 }}>*</i>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          ref={$controllers.comp_nm}
                        />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-form-label col-sm-3 text-end">
                        {compGB === "" &&
                          t(
                            "commonNav.registrationCorpModal.companyUniqueCode"
                          )}
                        {compGB === "A" &&
                          t(
                            "commonNav.registrationCorpModal.customsUniqueCode"
                          )}
                        {compGB === "B" &&
                          t(
                            "commonNav.registrationCorpModal.customsUniqueCode"
                          )}
                        {compGB === "C" &&
                          t("commonNav.registrationCorpModal.carrierCode")}
                        {compGB === "D" &&
                          t(
                            "commonNav.registrationCorpModal.insuranceCompanyCode"
                          )}
                        {compGB === "E" &&
                          t(
                            "commonNav.registrationCorpModal.customsBrokerCode"
                          )}
                        {compGB === "F" &&
                          t("commonNav.registrationCorpModal.bondedAreaCode")}
                        {(compGB === "E" || compGB === "F") && (
                          <i style={{ color: "red", fontWeight: 700 }}>*</i>
                        )}
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          placeholder=""
                          ref={$controllers.comp_c_num}
                        />
                      </div>
                    </div>

                    <div
                      className="mb-3 row"
                      style={
                        compGB !== "B"
                          ? { display: "none" }
                          : { display: "flex" }
                      }
                    >
                      <label className="col-form-label col-sm-3 text-end">
                        {t("commonNav.registrationCorpModal.forwarderCode")}
                        <i style={{ color: "red", fontWeight: 700 }}>*</i>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          placeholder=""
                          ref={$controllers.fwd_no}
                        />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-form-label col-sm-3 text-end">
                        {t("commonNav.registrationCorpModal.ceoName")}
                        <i style={{ color: "red", fontWeight: 700 }}>*</i>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          ref={$controllers.comp_ceo_nm}
                        />
                      </div>
                    </div>

                    <div className="mb-3 row" style={{ display: "none" }}>
                      <label className="col-form-label col-sm-3 text-end">
                        {t("commonNav.registrationCorpModal.address")}
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          ref={$controllers.comp_addr}
                        />
                      </div>
                    </div>

                    <div className="mb-3 row" style={{ display: "none" }}>
                      <label className="col-form-label col-sm-3 text-end">
                        {t("commonNav.registrationCorpModal.compType")}
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          ref={$controllers.comp_upte}
                        />
                      </div>
                    </div>

                    <div className="mb-3 row" style={{ display: "none" }}>
                      <label className="col-form-label col-sm-3 text-end">
                        {t("commonNav.registrationCorpModal.compKind")}
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          ref={$controllers.comp_jong}
                        />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-form-label col-sm-3 text-end">
                        {t("commonNav.registrationCorpModal.compTel")}
                        <i style={{ color: "red", fontWeight: 700 }}>*</i>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          ref={$controllers.comp_tel}
                        />
                      </div>
                    </div>

                    <div className="mb-3 row" style={{ display: "none" }}>
                      <label className="col-form-label col-sm-3 text-end">
                        {t("commonNav.registrationCorpModal.compFax")}
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          ref={$controllers.comp_fax}
                        />
                      </div>
                    </div>

                    <div className="mb-3 row" style={{ display: "none" }}>
                      <label className="col-form-label col-sm-3 text-end">
                        {t("commonNav.registrationCorpModal.addrNum")}
                      </label>
                      <div className="col-sm-9">
                        <input
                          maxLength={5}
                          type="text"
                          className="form-control"
                          ref={$controllers.comp_zip}
                        />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-form-label col-sm-3 text-end">
                        {t("commonNav.registrationCorpModal.compEmail")}
                        <i style={{ color: "red", fontWeight: 700 }}>*</i>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="email"
                          className="form-control"
                          placeholder={t(
                            "commonNav.registrationCorpModal.placeholderCompEmail"
                          )}
                          ref={$controllers.comp_mail}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-form-label col-sm-3 text-end">
                      {t("commonNav.registrationCorpModal.agreeTerms")}
                      <i style={{ color: "red", fontWeight: 700 }}>*</i>
                    </label>
                    <div className="col-sm-9">
                      <div className="form-group d-flex flex-row justify-content-start align-items-center text-left mr-2 font-weight-bold">
                        <label className="container_check m-0 p-0 mr-3">
                          <input
                            type="checkbox"
                            className="position-static"
                            onChange={(e) => {
                              let val = e.target.checked;
                              for (let key in $termsController) {
                                if ($termsController[key].current) {
                                  $termsController[key].current.checked = val;
                                }
                              }
                            }}
                          />
                          <span className="checkmark" />
                        </label>
                        {t("commonNav.registrationCorpModal.agreeAll")}
                      </div>

                      <div className="d-flex flex-row flex-wrap">
                        <div className="form-group d-flex flex-row justify-content-start align-items-center text-left mr-2">
                          <label className="container_check m-0 p-0 mr-3">
                            <input
                              type="checkbox"
                              className="position-static"
                              ref={$termsController.termsOfUse}
                            />
                            <span className="checkmark" />
                          </label>
                          <Link
                            to="/Terms/termsOfUse"
                            target="_blank"
                            className="align-middle"
                          >
                            {t("commonNav.registrationCorpModal.termsOfUse")}
                          </Link>
                        </div>
                        <div className="form-group d-flex flex-row justify-content-start align-items-center text-left mr-2">
                          <label className="container_check m-0 p-0 mr-3">
                            <input
                              type="checkbox"
                              className="position-static"
                              ref={$termsController.mallOperationPolicy}
                            />
                            <span className="checkmark" />
                          </label>
                          <Link
                            to="/Terms/mallOperationPolicy"
                            target="_blank"
                            className="align-middle"
                          >
                            {t(
                              "commonNav.registrationCorpModal.mallOperationPolicy"
                            )}
                          </Link>
                        </div>
                        <div className="form-group d-flex flex-row justify-content-start align-items-center text-left mr-2">
                          <label className="container_check m-0 p-0 mr-3">
                            <input
                              type="checkbox"
                              className="position-static"
                              ref={$termsController.talkOperationPolicy}
                            />
                            <span className="checkmark" />
                          </label>
                          <Link
                            to="/Terms/talkOperationPolicy"
                            target="_blank"
                            className="align-middle"
                          >
                            {t(
                              "commonNav.registrationCorpModal.talkOperationPolicy"
                            )}
                          </Link>
                        </div>
                        <div className="form-group d-flex flex-row justify-content-start align-items-center text-left mr-2">
                          <label className="container_check m-0 p-0 mr-3">
                            <input
                              type="checkbox"
                              className="position-static"
                              ref={$termsController.privacyPolicy}
                            />
                            <span className="checkmark" />
                          </label>
                          <Link
                            to="/Terms/privacyPolicy"
                            target="_blank"
                            className="align-middle"
                          >
                            {t("commonNav.registrationCorpModal.privacyPolicy")}
                          </Link>
                        </div>
                        <div className="form-group d-flex flex-row justify-content-start align-items-center text-left mr-2">
                          <label className="container_check m-0 p-0 mr-3">
                            <input
                              type="checkbox"
                              className="position-static"
                              ref={$termsController.disclaimer}
                            />
                            <span className="checkmark" />
                          </label>
                          <Link
                            to="/Terms/disclaimer"
                            target="_blank"
                            className="align-middle"
                          >
                            {t("commonNav.registrationCorpModal.disclaimer")}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn_1"
              disabled={loading}
              onClick={() => {
                actionSave();
              }}
            >
              {t("commonNav.registrationCorpModal.requestJoin")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
